import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const transaksiKeluarDetailTable = (
  handleUploadBuktiTransaksi,
  handleCetakBuktiPengeluaran,
  handlePindahAnggaran,
  handleDeleteDetail,
  handleShowDetail
) => {
  return [
    {
      title: "Tanggal Transaksi",
      render: (rowData) => {
        return <span>{rowData.tanggal_transaksi_keluar}</span>;
      },
    },
    {
      title: "Nomor Transaksi",
      render: (rowData) => {
        return <span>{rowData.nomor_transaksi_keluar}</span>;
      },
    },
    {
      title: "Pelaksana",
      render: (rowData) => {
        return <span>{rowData.nama_pelanggan}</span>;
      },
    },
    {
      title: "Keterangan Transaksi Keluar",
      render: (rowData) => {
        return <span>{rowData.keterangan_transaksi_keluar}</span>;
      },
    },
    {
      title: "Jumlah",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.jumlah_transaksi_keluar)}</span>;
      },
    },
    {
      title: "Via Bayar",
      render: (rowData) => {
        return <span>{rowData.nama_akun_via_bayar_keluar}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleUploadBuktiTransaksi(rowData)}
            >
              Bukti
            </button>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleCetakBuktiPengeluaran(rowData)}
            >
              Cetak
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleDeleteDetail(rowData)}
            >
              Hapus
            </button>
            <button
              className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleShowDetail(rowData)}
            >
              <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
            </button>
            <button
              className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handlePindahAnggaran(rowData)}
            >
              <FontAwesomeIcon icon="fa-solid fa-arrow-right-arrow-left" />
            </button>
          </>
        );
      },
    },
  ];
};
